import { MultipleViewTypeListActiveItemPreviewCloseButton } from '../../../MultipleViewTypeList'
import { PageEmptyState } from '../../../PageEmptyState'

import * as styles from './RentalPortalApplicantsPreviewEmpty.module.css'

function RentalPortalApplicantsPreviewEmpty({
  onClosePreview,
  ...emptyStateProps
}) {
  return (
    <div className={styles.RentalPortalApplicantsPreviewEmpty}>
      <div className={styles.close}>
        <MultipleViewTypeListActiveItemPreviewCloseButton
          onClose={onClosePreview}
        />
      </div>
      <PageEmptyState {...emptyStateProps} className={styles.emptyState} />
    </div>
  )
}

export default RentalPortalApplicantsPreviewEmpty
